import { bgDesc2style } from './bgDesc2style.js';
import { is } from '../is.js';

/**
 * Extract default fill of buttons as background.
 * Rewire all creative's backgrounds into style.
 * Map backgrounds into slides and widgets by id.
 * @param schema
 * @return {*}
 */
export function rewireBackgrounds(schema) {
  const getBackgroundById = (id) => schema.backgrounds[id];

  for (const widgetId in schema.widgets) {
    const widget = schema.widgets[widgetId];
    /*
     For close button widget: create "placeholder" background layer,
     styles, include state related, will be generated in button-widget.js
      Thus, these widget will not have own background and rely only on bgLayers.
    */
    if (is.widget.buttonType(widget)) {
      const defaultFill = widget.styledStates?.default?.fillColor;
      if (defaultFill) {
        const bgKey = `fill_${widgetId}`;
        widget.backgrounds.push(bgKey);
        schema.backgrounds[bgKey] = {
          id: bgKey,
        };
      }
    }
  }

  for (const backgroundId in schema.backgrounds) {
    schema.backgrounds[backgroundId] = bgDesc2style(
      schema.backgrounds[backgroundId],
    );
  }

  for (const widgetId in schema.widgets) {
    const widget = schema.widgets[widgetId];
    widget.backgrounds = (widget.backgrounds ?? []).map(getBackgroundById);
  }

  schema.slides.forEach((slide) => {
    slide.backgrounds = slide.backgrounds.map(getBackgroundById);
  });

  schema.classes.forEach((classDescription) => {
    if (classDescription.type === 'image') {
      classDescription.overlays = (classDescription.overlays ?? []).map(
        getBackgroundById,
      );

      if (classDescription.pollOptionResultStates) {
        if (classDescription.pollOptionResultStates.notSelected) {
          mapOverlays(classDescription.pollOptionResultStates.notSelected);
        }
        if (classDescription.pollOptionResultStates.selected) {
          mapOverlays(classDescription.pollOptionResultStates.selected);
        }
      }

      if (classDescription.quizOptionResultStates) {
        if (classDescription.quizOptionResultStates.incorrectNotSelected) {
          mapOverlays(
            classDescription.quizOptionResultStates.incorrectNotSelected,
          );
        }
        if (classDescription.quizOptionResultStates.incorrectSelected) {
          mapOverlays(
            classDescription.quizOptionResultStates.incorrectSelected,
          );
        }
        if (classDescription.quizOptionResultStates.correctNotSelected) {
          mapOverlays(
            classDescription.quizOptionResultStates.correctNotSelected,
          );
        }
        if (classDescription.quizOptionResultStates.correctSelected) {
          mapOverlays(classDescription.quizOptionResultStates.correctSelected);
        }
      }
    }

    if (classDescription.type === 'result') {
      rewireOverlayToBackground(
        classDescription.backgrounds,
        classDescription.quizOptionResultStates,
      );
      rewireOverlayToBackground(
        classDescription.backgrounds,
        classDescription.pollOptionResultStates,
      );
    }
  });

  function rewireOverlayToBackground(initialBackgrounds = [], item) {
    for (let key in item) {
      let state = item[key];
      if (state?.overlays) {
        state.backgrounds = initialBackgrounds.concat(state.overlays);
      }
    }
  }

  function mapOverlays(entry) {
    entry.overlays = (entry.overlays ?? [])
      .map(getBackgroundById)
      .map(({ style }) => style.background);
  }

  return schema;
}
